/* eslint-disable no-console */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Spinner from 'components/Spinner';
import { required, maxLength } from 'helpers/validate';
import { validateForm } from 'helpers/validateForm';
import InputWithValidation from '../../../components/InputWithValidation';
import DualButtons from '../../../components/DualButtons';
import styles from './custom-event-type-form.scss';

const CustomEventTypeForm = ({ save, customEventTypeId, customEventTypes }) => {
  const initialCustomEventType = customEventTypes.filter((cev) => cev.id === customEventTypeId)[0];

  const [isSaving, setIsSaving] = useState(false);
  const [customEventType, setCustomEventType] = useState(initialCustomEventType || { name: '' });
  const [errors, setErrors] = useState({});
  const history = useHistory();

  const validationRules = {
    name: [required(), maxLength(100)],
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSaving(true);

    const validationErrors = validateForm(validationRules, customEventType);
    if (validationErrors.hasErrors) {
      setErrors(validationErrors);
      setIsSaving(false);
      return;
    }

    if (customEventTypes.filter((cev) => cev.id !== customEventTypeId && cev.name === customEventType.name).length > 0) {
      setErrors({ hasErrors: true, name: [`Custom event type with name '${customEventType.name}' already exists`] });
      setIsSaving(false);
      return;
    }

    save(customEventType)
      .then(() => {
        history.push('/settings/custom-event-types');
      })
      .catch((e) => {
        setErrors(e);
        setIsSaving(false);
        return Promise.resolve();
      });
  };

  const handleCancel = () => {
    history.push('/settings/custom-event-types');
  };

  const handleOnChange = ({ target }) => {
    setCustomEventType({ name: target.value });
  };

  return (
    <div>
      {isSaving && <Spinner />}
      <div className={styles.addContainer}>
        <form onSubmit={handleSubmit}>
          <InputWithValidation
            label="Name"
            placeholder="Name"
            type="text"
            value={customEventType.name}
            name="name"
            onChange={handleOnChange}
            errors={errors}
          />
          <input type="submit" className="hidden-submit" />
        </form>
      </div>
      <DualButtons
        leftFunction={handleCancel}
        leftText="Cancel"
        rightFunctionDisabled={isSaving}
        rightText="Save"
        rightFunction={handleSubmit}
        theme="rightPink"
      />
    </div>
  );
};

export default CustomEventTypeForm;
